module.exports = __webpack_public_path__ + "static/media/local-weather-app-preview.6348ffcd.jpg";